import { IDict } from '@/models/types/dict';
import { Tabs } from 'antd';
import React, { memo } from 'react';
import styles from './index.less';

const { TabPane } = Tabs;

interface ITabProps {
  onDictChange: (val: string) => void;
  data: Partial<IDict>[];
  showAll?: boolean
  defaultKey?: string
}

const Tab: React.FC<ITabProps> = ({
  onDictChange,
  data,
  defaultKey = '',
  showAll = true,
}) => {
  return (
    <div className={styles.tabs}>
      <Tabs onChange={onDictChange} defaultActiveKey={defaultKey}>
        {showAll && <TabPane tab="全部" key={''}></TabPane>}
        {data.map(item => {
          return <TabPane tab={item.name} key={item.value}></TabPane>
        })}
      </Tabs>
    </div>
  );
};

export default memo(Tab);